import { MediaObject } from '@anm/hosting-player';
import isStreamVideo from '@anm/helpers/is/isStreamVideo';

const checkCanDownload = (sources?: MediaObject[]) => !sources?.some(s => isStreamVideo(s.path));

export default checkCanDownload;
